// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"166":"50590a3e","453":"2b10c8bd","465":"e91c177e"}[chunkId] + ".chunk.js";
};